import templateUrl from 'servicestack/auto-query/auto-query-date-filter.htm';

const component  = {
    bindings: {
        filter: '<',
        icon: '@'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default component;